import * as types from 'store/mutation-types'
import isNeedRefresh from 'utils/isNeedRefresh'
import moment from 'moment-timezone'
import choiceFilter from 'utils/choiceFilter'
import { MARKET_TYPE, SEC_TYPE } from 'const/stock'

const state = {
  type: 1,
  active: 1,
  list: [],
  fourLockData: [],
  nineLockData: []
}

function same(comparedStock, stock) {
  if (!comparedStock || comparedStock.secType !== stock.secType) {
    return false
  }
  return comparedStock.webLocal.symbol === stock.webLocal.symbol
}

const mutations = {
  [types.INIT_OPEN_STOCK_LIST](state, [type = 1, stocks = [], activeStock]) {
    state.type = type
    state.list = type === 1 ? [] : stocks.slice(0, state.type)
    state.active = state.list.findIndex(stock => same(activeStock, stock))
  },
  [types.SET_STOCK_TO_OPEN_LIST](state, [index, stock = null]) {
    state.list[index] = stock
    state.list = [...state.list]
  },
  [types.SET_ACTIVE_VIEW_SLOT](state, index) {
    state.active = Math.min(Math.max(0, index), state.type - 1)
  },
  [types.RE_ORDER_VIEW_LIST](state, [params, stocks]) {
    if (stocks.length > 0) {
      state.list = state.type === 1 ? [] : stocks.slice(0, state.type)
      params.forEach((item1, index) => {
        if (item1) {
          state.list[index] = stocks.find(item => {
            return item.webLocal.symbol === item1.webLocal.symbol
          })
        }
      })
    }
  },
  [types.SYNC_LOCK_DATA](state, params) {
    if (state.type === 4) {
      state.fourLockData = params
    } else if (state.type === 9) {
      state.nineLockData = params
    }
  }
}

const getters = {
  multiviewStocks(state) {
    const result = {}
    state.list.forEach(stock => {
      if (stock) {
        stock.digits = choiceFilter(stock)
        if (stock.secType === 'STK') {
          result[stock.symbol] = stock
        } else {
          result[stock.webLocal.symbol] = stock
        }
      }
    })
    return result
  },
  multiviewLockedData(state) {
    return {
      4: state.fourLockData,
      9: state.nineLockData
    }
  },
  multiviewLockType(state) {
    return state.type
  }
}

const actions = {
  initMultiViews({ commit, getters }, type) {
    commit(types.INIT_OPEN_STOCK_LIST, [
      type,
      getters.tradeStocks,
      getters.activeStock
    ])
  },
  refreshMultiviewHKStocks({ state, dispatch }) {
    const HKItems = []
    state.list
      .filter(stock => stock.market === 'HK')
      .forEach(stock => {
        HKItems.push(stock.symbol)
      })
    return dispatch('refreshMultiStock', { market: 'HK', items: HKItems })
  },
  refreshMultiviewStocks({ state, dispatch, getters }) {
    const ret = []
    const HKItems = []
    const USItems = []
    state.list.forEach(stock => {
      if (isNeedRefresh(stock, getters)) {
        if (stock.market === MARKET_TYPE.HK) {
          if (!getters.hasHkLv2Permission) {
            ret.push(Promise.resolve(stock))
          } else {
            HKItems.push(stock.symbol)
          }
        } else if (
          stock.market === MARKET_TYPE.US &&
          stock.secType !== SEC_TYPE.OPT
        ) {
          USItems.push(stock.symbol)
        } else {
          ret.push(dispatch('refreshOneStock', stock))
        }
      } else {
        ret.push(Promise.resolve(stock))
      }
    })

    ret.push(
      dispatch('refreshMultiStock', { market: MARKET_TYPE.HK, items: HKItems })
    )
    ret.push(
      dispatch('refreshMultiStock', { market: MARKET_TYPE.US, items: USItems })
    )
    return Promise.all(ret)
  },
  setViewSlot({ commit, dispatch }, [index, stock]) {
    if (stock) {
      return dispatch('addOrActivateTradeStock', stock).then(stock => {
        commit(types.SET_STOCK_TO_OPEN_LIST, [index, stock])
      })
    } else {
      commit(types.SET_STOCK_TO_OPEN_LIST, [index, stock])
    }
  },
  markSlotActive({ state, commit, dispatch }, index) {
    commit(types.SET_ACTIVE_VIEW_SLOT, index)
    if (state.list[index]) {
      return dispatch('activateStock', state.list[index])
    }
  },
  reorderDataList({ getters, commit, dispatch }, params) {
    commit(types.RE_ORDER_VIEW_LIST, [params, getters.tradeStocks])
    return Promise.resolve(true)
  },
  syncLockData({ commit, state, dispatch }, params) {
    commit(types.SYNC_LOCK_DATA, params)
    return params
  },
  fetchViewLockData({ state, commit, dispatch }) {
    const promiseArr = []
    let param
    if (state.type === 4) {
      param = state.fourLockData
    } else if (state.type === 9) {
      param = state.nineLockData
    }
    param.forEach(item => {
      if (item) {
        if (item.secType === SEC_TYPE.OPT) {
          const [
            symbol,
            expiryDateStr,
            strike,
            right
          ] = item.webLocal.symbol.split(' ')
          const expiry = moment
            .tz(expiryDateStr, 'America/New_York')
            .toDate()
            .getTime()
          const param = Object.assign({}, item, {
            symbol,
            expiry,
            strike,
            right
          })
          return promiseArr.push(dispatch('addOrActivateTradeStock', param))
        }
        return promiseArr.push(dispatch('addOrActivateTradeStock', item))
      }
    })
    return Promise.all(promiseArr).then(response => {
      if (!response) {
        return null
      }
      return response
    })
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
